import { render, staticRenderFns } from "./promotion-banner.vue?vue&type=template&id=7f536938&scoped=true&lang=pug&"
import script from "./promotion-banner.vue?vue&type=script&lang=js&"
export * from "./promotion-banner.vue?vue&type=script&lang=js&"
import style0 from "./promotion-banner.vue?vue&type=style&index=0&id=7f536938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f536938",
  null
  
)

component.options.__file = "promotion-banner.vue"
export default component.exports